import { FC } from "react";
import { useParams } from "react-router-dom";

import { StationRouteEditFormDrawer } from "@ryde/layout";
import { useCrudNavigate } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

interface IStationRouteEdit {
  isAddRoute?: boolean;
}

export const StationRouteEdit: FC<IStationRouteEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate("stationRoute");
  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <StationRouteEditFormDrawer
      type={DrawerType.StationRouteEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
